import React, { useCallback } from 'react';
import { type ReferenceRecord } from './pillFields';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';
import AhaBaseEventListener from 'components/common/AhaBaseEventListener';
import { type Task } from 'components/framework/models';

type TaskCheckboxProps = {
  record: Task;
  setRecord: (record: ReferenceRecord | null) => void;
};

const TaskCheckbox: React.FC<TaskCheckboxProps> = ({ record, setRecord }) => {
  let iconClass = 'aha-icon-pending';

  if (record.completedByMe || record.completedDate) {
    iconClass = 'aha-icon-complete';
  }

  const assignedToMe =
    record.taskUsers.length === 0 ||
    record.taskUsers.find(
      taskUser => taskUser.assignee.id === window.currentUser?.id
    );

  const onClick = useCallback(
    async event => {
      if (!assignedToMe) return;
      if (!window.currentUser) return;

      event.preventDefault();

      if (record.taskUsers.length === 0) {
        record.assignUser(window.currentUser.id);
        await record.save();
      }

      await record.updateStatusForAssignee(
        window.currentUser.id,
        record.completedByMe ? 'PENDING' : 'COMPLETE'
      );
      setRecord(record);
    },
    [assignedToMe, record, setRecord]
  );

  return (
    <span className='task-status-icon'>
      <AhaBaseEventListener
        Component='aha-icon'
        eventListeners={{ click: onClick }}
        icon={iconClass}
        disabled={customElementBoolAttr(!assignedToMe)}
      />
    </span>
  );
};

export default TaskCheckbox;
